<template>
    <div class="field field--wysiwyg">
        <div>
            <label
                :for="id"
                class="title bold static-label"
            >
                {{ label }}
            </label>

            <quill-editor
                name="intro"
                :options="editorOption"
                v-model="inputVal"
            />
        </div>
        <small
            v-if="errors.length"
            v-html="errors.join('<br/>\n')"
            class="text-danger"></small>
        <small v-else-if="hint">{{ hint }}</small>
    </div>
</template>

<script>
    import { quillEditor } from 'vue-quill-editor'
    export default {
        name: 'CoreTextarea',
        components: {
            quillEditor
        },
        data() {
            return {
                error: false,
                type: null,
                editorOption: {
                    modules: {
                        'syntax': false
                        // 'toolbar': [
                        //     [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }, { 'header': 4 }],
                        //     ['bold', 'italic', 'underline', 'strike'],
                        //     [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                        //     ['link']
                        // ]
                    }
                }
            }
        },

        props: {
            id: {
                type: String,
                default() { return `text-input-${this._uid}`}
            },
            label: {
                type: String,
                default: ''
            },
            hint: {
                type: String,
                default: ''
            },
            rows: {
                type: Number,
                default: 10
            },
            placeholder: {
                type: String,
                defualt: ''
            },
            value : {
                type: String,
                required: false,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            errors: {
                type: Array,
                default: () => []
            }
        },

        computed: {
            inputVal: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                }
            }
        }

        // watch: {
        //     filledData: {
        //         handler() {
        //             this.$emit('input', this.filledData)
        //         }
        //     }
        // }
    }
</script>

<style lang="scss" scoped>
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.snow.css';

.field--wysiwyg {
    &::v-deep .quill-editor {
        .ql-toolbar.ql-snow {
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
            border-color: var(--border-grey-50);
        }

        .ql-snow {
            border-color: var(--border-grey-50);
        }

        .ql-container {
            font: normal var(--rem-size) / 1.2 'proxima-nova', sans-serif;
        }

        .ql-editor {
            font-size: 1rem;
        }

        .ql-editor.ql-blank::before {
            font: inherit;
            font-size: 1rem;
        }
    }

    & > div {
        position: relative;
    }

    .static-label {
        display: block;
        margin-bottom: 0.5rem;
        color: var(--text-dark);
    }
}
</style>
